import { useContext, type ReactNode } from "react";
import { createPortal } from "react-dom";
import { Construction } from "lucide-react";
import { HeaderSlotContext, useIsDesktop } from "./headerSlots";

export function ComingSoon({ title, slug }: { title: string; slug: string }) {
  return (
    <section data-testid={`coming-soon-${slug}`} className="animate-rise">
      <h1 className="font-display text-4xl font-bold uppercase tracking-tight text-white sm:text-5xl">{title}</h1>
      <div className="mt-10 flex flex-col items-center justify-center rounded-sm border border-dashed border-white/15 bg-surface/60 px-6 py-20 text-center">
        <Construction className="h-10 w-10 text-zinc-500" aria-hidden />
        <h2 data-testid="coming-soon-heading" className="mt-6 font-display text-2xl font-bold uppercase tracking-tight text-white">
          {slug === "payments" ? "Coming later – no disbursement in this app" : "Coming in later milestones"}
        </h2>
        <p className="mt-3 max-w-md text-sm text-zinc-400">
          {title} is part of a future GamedayTime milestone. No data is shown here until the feature ships.
        </p>
      </div>
    </section>
  );
}

// Renders the page title and actions into the AppShell header bar; falls back inline outside the shell.
export function PageHeader({ title, children }: { title: string; children?: ReactNode }) {
  const slots = useContext(HeaderSlotContext);
  const desktop = useIsDesktop();
  if (!slots) {
    return (
      <header className="mb-8 flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
        <h1 data-testid="page-title" className="font-display text-3xl font-light text-white">{title}</h1>
        {children}
      </header>
    );
  }
  const target = desktop ? slots.actions : slots.mobileActions;
  return (
    <>
      {slots.title && createPortal(<h1 data-testid="page-title" title={title} className="truncate font-display text-lg font-light text-white sm:text-xl lg:text-3xl">{title}</h1>, slots.title)}
      {children && target && createPortal(<div data-testid="page-actions" className="flex flex-wrap items-center gap-2 lg:justify-end lg:gap-3">{children}</div>, target)}
    </>
  );
}
